export default __webpack_public_path__ + "static/media/TheGrefg.9016b07c.webp";